import { css } from '@emotion/react';

export const button = ({ theme, buttonType }) => css`
    cursor: pointer;
    font-weight: ${theme.typography.fontWeight.bold};

    ${buttonType === 'text'
        ? `
    position: relative;
    color: ${theme.palette.darkBlue};
    font-family: ${theme.typography.fontFamily.body};
    font-size: 1.6rem;
    line-height: 1.5;
    appearance: none;
    border: none;
    background-color: transparent;
    padding: 0;
    white-space: nowrap;

    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0;
        height: 1px;
        background-color: ${theme.palette.mediumBlue};
        transition: width ${theme.animation.duration.fast} ease-in-out;
    }

    > i {
        margin-left: 5px;
        position: relative;
        left: 0;
        transition: left ${theme.animation.duration.fast} ease-in-out;
    }

    &:hover,
    &:focus {
        > i {
            left: 5px;
        }
        &:after {
            width: calc(100% - 34px);
        }
    }
    `
        : `
    font-family: ${theme.typography.fontFamily.button};
    font-size: 1.5rem;
    text-align: center;
    color: ${
        buttonType === 'white' ? theme.palette.darkBlue : theme.palette.white
    };
    background-color: ${
        buttonType === 'outline'
            ? 'transparent'
            : buttonType === 'white'
            ? theme.palette.white
            : theme.palette.darkBlue
    };
    border-radius: 6px;
    border: 2px solid ${
        buttonType === 'outline'
            ? theme.palette.mediumBlue
            : buttonType === 'white'
            ? theme.palette.white
            : theme.palette.darkBlue
    };
    padding: 15px 30px;
    transition: background-color ${
        theme.animation.duration.medium
    }, border-color ${theme.animation.duration.medium}, color ${
              theme.animation.duration.medium
          };

    &:hover,
    &:focus {
        background-color: ${
            buttonType === 'white'
                ? theme.palette.darkBlue
                : theme.palette.mediumBlue
        };
        border-color: ${
            buttonType === 'white'
                ? theme.palette.darkBlue
                : theme.palette.mediumBlue
        };
        ${buttonType === 'white' && `color: ${theme.palette.white};`}
    }
    `}
`;
